import { render, staticRenderFns } from "./Cohorts.vue?vue&type=template&id=6f7e728e&scoped=true&"
import script from "./Cohorts.vue?vue&type=script&lang=js&"
export * from "./Cohorts.vue?vue&type=script&lang=js&"
import style0 from "./Cohorts.vue?vue&type=style&index=0&id=6f7e728e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7e728e",
  null
  
)

export default component.exports